import api from '@/store/api/address'

export default {
    namespaced: true,
    actions: {
        async searchByPostcode ({dispatch}, data) {
            try {
                const response = await api.searchByPostcode(data)
                return response.data
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        async getAddressDetails ({dispatch}, data) {
            try {
                const response = await api.getAddressDetails(data)
                return response.data
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        }
    }
}
